import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../shared/services/authentication.service';
import { WtStorageService } from '../shared/services/wt-storage.service';
import { Capacitor } from '@capacitor/core';
import { CachingService } from '../shared/services/caching.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private oauthService: OAuthService,
    private authenticationService: AuthenticationService,
    private readonly wtStorage: WtStorageService,
    private cachingService: CachingService
  ) {}

  externalAPiList = ['api.what3words.com', `thingproxy.freeboard.io`, 'www.googleapis.com'];

  // External access endpoints that should use their own token (not OAuth)
  externalAccessEndpoints = ['ExternalAccess', 'ExternalPolicies', 'ExternalAccountSettings', 'ExternalJob', 'ExternalIncident', 'ExternalChecklistItem', 'ExternalDocuments', 'ExternalDocumentCategories'];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.externalAPiList.findIndex((r) => req.url.indexOf(r) > -1) > -1) {
      return next.handle(req);
    }

    // Skip OAuth token injection for external access endpoints - they use their own Bearer token
    if (this.externalAccessEndpoints.some((endpoint) => req.url.includes(endpoint))) {
      return next.handle(req);
    }

    if (this.oauthService.hasValidAccessToken()) {
      const accessToken = this.wtStorage.getItem('access_token');
      const account = this.authenticationService.getCurrentAccount();
      const header = { Authorization: `Bearer ${accessToken}` };
      const cachedAccount = this.cachingService.getCurrentAccount();

      const isMobile = Capacitor.getPlatform() !== 'web';

      if (isMobile) {
        header['m'] = 'm';
      }

      if (account) {
        header['aId'] = `${account.id}`;
      }

      // Workaround for mobile app to get the correct accountID for base configuration when switching accounts
      if (isMobile && (req.url.includes('configuration/app/base') && cachedAccount?.accountID)) {
        header['aId'] = `${cachedAccount?.accountID}`;
      }

      req = req.clone({ setHeaders: header });
    }

    return next.handle(req);
  }
}
